import { Select } from "../utilities";
import { QueovalDateTime, GQueovalDik, QueovalDate } from '../global';


export class Invoice {
  public Ident: string;
  public Name: string;
  public Path: string;
  public Date: QueovalDateTime;
  public ReadOnly: boolean;
  public DevisPerdu: boolean;
  public DatePerdu: QueovalDate;
  public DevisSigne: boolean;
  public DateSignature: QueovalDate;

  constructor() {
    this.Date = new QueovalDateTime();
  }
}


export class Corporation {
  public Id: string;
  public SocialReason: string;
  public HomePhoneNumber: string;
  public PhoneNumber: string;
  public Email: string;
  public PersonneMorale: string;
  public IsClient: boolean;
  constructor() {
    this.Id = '';
    this.SocialReason = '';
    this.HomePhoneNumber = '';
    this.PhoneNumber = '';
    this.Email = '';
    this.PersonneMorale = 'Personne Morale';
    this.IsClient = false;
  }
}

export class Person {
  public Id: string;
  public Civility: string;
  public Value: string;
  public Firstname: string;
  public Lastname: string;  
  public PhoneNumber: string;
  public MobilePhoneNumber: string;
  public Email: string;
  public ProfilePicture: string;
}

export class ActionCoHistory {
  public Id: string;
  public BoTypeValue: string;
  public BoTypeText: string;
  public BoTypes: Array<Select>;
  public Person: Person;
  public Date: QueovalDateTime;
  public Type: ActionCoHistoryType;
  public Label: string;
  public Values: Array<string>;
  public ReadOnly: boolean;
  public Responses: Array<ActionCoResponse>;
}
export class ActionCoResponse {
  public Person: string;
  public Date: QueovalDateTime;
  public Value: string;
}

export class ActionCoReply {
  public HistoryId: string;
  public Value: string;
}
export enum ActionCoHistoryType {
  comment = 'comment',

  quoteCreate = 'quoteCreate',
  quoteUpdate = 'quoteUpdate',
  quoteGeneration = 'quoteGeneration',
  quoteWin = 'quoteWin',
  quoteLose = 'quoteLose',

  sendMail = 'sendMail',

  createAction = 'createAction',
  updateAction = 'updateAction',
  win = 'win',
  lose = 'lose'
}
export enum ActionCoTypeDevis {
  CAC = 'CAC',
  lettreDeMission = 'LDM',
  Devis = 'DEVIS',
  Produit = 'PRODUIT'
}

export class RequiredActioCoProps {
  public Ints: Array<IntRequiredActionCo>;
  public Strings: Array<StringRequiredActionCo>;
  public Dates: Array<DateRequiredActionCo>;
  public Monetaries: Array<MonetaryRequiredActionCo>;
  public Booleans: Array<BooleanRequiredActionCo>;
  constructor() {
    this.Ints = new Array<IntRequiredActionCo>();
    this.Strings = new Array<StringRequiredActionCo>();
    this.Dates = new Array<DateRequiredActionCo>();
    this.Monetaries = new Array<MonetaryRequiredActionCo>();
    this.Booleans = new Array<BooleanRequiredActionCo>();
  }
}
export class PropRequiredActionCo<T>
{
  public Label: string;
  public Combo: Array<GQueovalDik<string, T>>;
  public ColumnName: string;
  public highlight: boolean;
  constructor(label: string = "", combo: Array<GQueovalDik<string, T>> | null = null, columnName: string = '') {
    this.Label = label;
    this.Combo = combo != null ? combo : new Array<GQueovalDik<string, T>>();
    this.ColumnName = columnName;
    this.highlight = false;
  }
}
export class IntRequiredActionCo extends PropRequiredActionCo<number>
{
  public Value: number | null;
  constructor(label: string = "", value: number | null = null, columnName: string = "", combo: Array<GQueovalDik<string, number>> | null = null) {
    super(label, combo, columnName);
    this.Value = value;
  }
}
export class StringRequiredActionCo extends PropRequiredActionCo<string>
{
  public Value: string | null;
  constructor(label: string = "", value: string | null = null, columnName: string = "", combo: Array<GQueovalDik<string, string>> | null = null) {
    super(label, combo, columnName);
    this.Value = value;
  }
}
export class DateRequiredActionCo extends PropRequiredActionCo<QueovalDateTime>
{
  public Value: QueovalDateTime | null;
  public DateMinutesList: Array<string>;
  constructor(label: string = "", value: QueovalDateTime | null = null, columnName: string = "", combo: Array<GQueovalDik<string, QueovalDateTime>> | null = null) {
    super(label, combo, columnName);
    this.Value = value;
    this.DateMinutesList = [];
  }
}
export class MonetaryRequiredActionCo extends PropRequiredActionCo<number>
{
  public Value: number | null;
  constructor(label: string = "", value: number | null = null, columnName: string = "", combo: Array<GQueovalDik<string, number>> | null = null) {
    super(label, combo, columnName);
    this.Value = value;
  }
}

export class BooleanRequiredActionCo extends PropRequiredActionCo<boolean>
{
  public Value: boolean | null;
  constructor(label: string = "", value: boolean | null = null, columnName: string = "", combo: Array<GQueovalDik<string, boolean>> | null = null) {
    super(label, combo, columnName);
    this.Value = value;
  }
}
